export default "__VITE_ASSET__Dt_l3qnD__"